import axios from "../../axios";
import { DummyResponse } from "./interfaces";

/**
 * actual api client
 */
export class DummyClient {
    async getGreeting(): Promise<string> {
        const response = await axios.get<DummyResponse>("dummy");
        return response.data.greeting;
    }
}
export const defaultDummyClient = new DummyClient();
